if ((typeof Shopify) === 'undefined') { Shopify = {}; }
if (!Shopify.formatMoney) {
  Shopify.formatMoney = function(cents, format) {
    var value = '',
        placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = (format || this.money_format);

    if (typeof cents == 'string') {
      cents = cents.replace('.','');
    }

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number/100.0).toFixed(precision);

      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
}

if (!Shopify.resizeImage) {
  Shopify.resizeImage=function(e,t){
    try{
      if("original"==t)
        return e;
      var n = e.match(/(.*\/[\w\-\_\.]+)\.(\w{2,4})/);
      return n[1]+"_"+t+"."+n[2]
    } catch(r) {
      return e;
    }
  }
}

window.van = window.van || {};
van.cacheSelectors = function () {
  van.cache = {
    // General
    $html                    : $('html'),
    $body                    : $('body'),
    // Collection Pages
    $changeView              : $('.change-view'),
    // Product Page
    $productImage            : $('#ProductPhotoImg'),
    $thumbImages             : $('#ProductThumbs').find('a.product-single__thumbnail'),
    $productImageWrap: $('#ProductPhoto')
  };
};
van.init = function () {
  van.cacheSelectors();
  van.productImageSwitch();
  van.sliderClickCallback();
};
van.getHash = function () {
  return window.location.hash;
};
van.productPage = function (options) {
  var moneyFormat = options.money_format,
      variant = options.variant,
      selector = options.selector;
  // Selectors
  var $productImage = $('#ProductPhotoImg'),
      $addToCart = $('#AddToCart'),
      $productPrice = $('#ProductPrice'),
      $comparePrice = $('#ComparePrice'),
      $saleTag = $('.Productsaletag'),
      $quantityElements = $('#quantity'),
      $addToCartText = $('#AddToCartText'),
      $addToCartTextDiscount = $('#AddToCart > span');
  if (variant) {
    // Update variant image, if one is set
    if (variant.featured_image) {
      var newImg = variant.featured_image,
          el = $productImage[0];
      Shopify.Image.switchImage(newImg, el, van.switchImage);
    }
    // Select a valid variant if available
    if (variant.available) {
      // Available, enable the submit button, change text, show quantity elements
      $addToCart.removeClass('disabled').prop('disabled', false);
      $addToCartText.html(" ADD TO CART");
      //$productPrice.html( Shopify.formatMoney(variant.price, moneyFormat) );
      
      $productPrice.html( Shopify.formatMoney(variant.price, moneyFormat) );
      
      $quantityElements.removeClass('disabled').prop('disabled', false);
      $addToCartTextDiscount.show();
      $comparePrice.show();
      $saleTag.show();
    } else {
      // Sold out, disable the submit button, change text, hide quantity elements
      $addToCart.addClass('disabled').prop('disabled', true);
      $addToCartText.html(" SOLD OUT");
      $productPrice.html(" SOLD OUT");
      $quantityElements.addClass('disabled').prop('disabled', true);
      $addToCartTextDiscount.hide();
      $comparePrice.hide();
      $saleTag.hide();
      
    }
     // Regardless of stock, update the product price
     //$productPrice.html( Shopify.formatMoney(variant.price, moneyFormat) );

      // Also update and show the product's compare price if necessary
      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(Shopify.formatMoney(variant.compare_at_price, moneyFormat)).show();
      } else {
        //$comparePrice.hide();
        $comparePrice.html(Shopify.formatMoney(variant.price + 500 , moneyFormat));
      }
  } else {
    // The variant doesn't exist, disable submit button.
    // This may be an error or notice that a specific variant is not available.
    // To only show available variants, implement linked product options:
    //   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
    $addToCart.addClass('disabled').prop('disabled', true);
    $addToCartText.html("Unavailable");
    $productPrice.html(" SOLD OUT");
    //$addToCartText.html(" SOLD OUT");
    $quantityElements.addClass('disabled').prop('disabled', true);
    $addToCartTextDiscount.hide();
    $comparePrice.hide();
    $saleTag.hide();
  }
};
van.productImageSwitch = function () {
  if (van.cache.$thumbImages.length) {
    // Switch the main image with one of the thumbnails
    // Note: this does not change the variant selected, just the image
    van.cache.$thumbImages.on('click', function(evt) {
      evt.preventDefault();
      var newImage = $(this).attr('href');
      van.switchImage(newImage, null, van.cache.$productImage);
    });
  }
};
van.sliderClickCallback = function () {
  $('.product-single__thumbnail img').click(function(e){
    e.preventDefault();
    var variant_img = $(this).attr('src');
    //var product_id = $(this).parent('a').parent('li').parent('ul').data('product');
    var product_id = $('#ProductThumbs').data('product');
    //alert(product_id);
    if($("#productSelect--"+product_id+" option[data-image='"+variant_img+"']").val() !== undefined && $("#productSelect--"+product_id+" option[data-image='"+variant_img+"']").attr("disabled") === undefined){
      var option1 = $("#productSelect--"+product_id+" option[data-image='"+variant_img+"']").data('option1');
      var option2 = $("#productSelect--"+product_id+" option[data-image='"+variant_img+"']").data('option2');
      var option3 = $("#productSelect--"+product_id+" option[data-image='"+variant_img+"']").data('option3');

        //if(option1 !== ""){
        //  $(".AddToCartForm--"+product_id).find("select[data-option='option1']").val(option1).change();
       // }
        if(option2 !== ""){
          $(".AddToCartForm--"+product_id).find("input[value='"+option2+"']").attr("checked", "true").change();
        }
        //if(option3 !== ""){
        //  $(".AddToCartForm--"+product_id).find("input[value='"+option3+"']").attr("checked", "true").change();
        //}
      
    }
  });
};

van.switchImage = function (src, imgObject, el) {
  // Make sure element is a jquery object
  var $el = $(el);
  $el.attr('src', src);
  var zoomSrc = src.replace('_medium','_1024x1024').replace('_large','_1024x1024');
  $el.attr('data-nv-zoom-img-url', zoomSrc);
  var w = window.innerWidth;
  if (w>767){
    $(function() {
      van.productImageZoom();
    });
  }
};
van.productImageZoom = function () {
  if (!van.cache.$productImageWrap.length || van.cache.$html.hasClass('supports-touch')) {
    return;
  }
  // Destroy zoom (in case it was already set), then set it up again
  van.cache.$productImageWrap.trigger('zoom.destroy');
  van.cache.$productImageWrap.addClass('nv_img_zoom').zoom({
    url: van.cache.$productImage.attr('data-nv-zoom-img-url')
  });
};

van.cartUpdatePopup = function () {
$.ajax({
  type: 'GET',
  url: '/cart.js',
  dataType: 'json',
  success: function(cart) {
  var cart_summary = $('#cart-popup');
  $(".CartCount").html(cart.item_count);
  if (cart_summary.length) {
    cart_summary.empty();
    $.each(cart, function(key, value) {
      if (key === 'items') { 
        var html = '';
        if (value.length) {
          html += '<div class="container">';
          html += '<form action="/cart" method="post">';
          html += '<ul class="cart-popup-ul-top">';
          html += '<li class="total-items"><b>Total: </b><span class="cart-current-items">'+cart.item_count+'</span> Items</li>';
          html += '<li class="total-price">'+ Shopify.formatMoney(cart.total_price, window.money_format) +'</li>';
          html += '</ul>';
          html += '<ul class="cart-popup-ul-middle">';
          $.each(value, function(i, item) {
            html += '<li>';
            html += '<a href="'+ item.url +'">';
            html += '<div class="cart-img-div">';
            html += '<img src="'+ Shopify.resizeImage(item.image, 'small') +'" alt="Image of '+ item.title +'" class="cart-item-image" />';
            html += '<span class="pop-qty-crat">'+ item.quantity +'</span>';
            html += '</div>';
            html += '<div class="cart-item-info">';
            html += '<span class="cart-item-title">'+ item.title +'</span>';
            html += '<p class="cart-item-price">'+ Shopify.formatMoney(item.price, window.money_format) +'</p>';
            html += '</div>';
            html += '<a href="/cart/change?line='+(i+1)+'&quantity=0" data-line="'+(i+1)+'" class="removeLineCartPop" rel="'+ item.variant_id +'">x</a>';
            html += '</a>';
            html += '</li>';
          });
          html += '</ul>';
          html += '<ul class="cart-popup-ul-bottom">';
          html += '<li><a href="/cart" class="btn--secondary btn cart__cartview">View My Cart</a></li><li>';
          html += '<a href="/checkout" class="btn btn--full cart__checkout Checkout">';
          html += '<img src="//cdn.shopify.com/s/files/1/0146/5289/9392/t/2/assets/checkout-button-icon.png?v=139293864916011936901545924114" alt="" class="addIcon" />';
          html += '<span id="CheckoutText">Secure Checkout</span>';
          html += '</a></li></ul></form></div>';
          cart_summary.removeClass('empty-popup');
        } else {
          html = '<div class="container"><ul class="cart-popup-ul-bottom"><li class="empty-cart-popup-msg">Your cart is empty. Did you forget to add something?</li><li><a href="/collections/all" class="btn btn--secondary">Shop Now</a></li></ul></div>';
          cart_summary.addClass('empty-popup');
        }
        cart_summary.html(html);
        
      }
    });
  }
    
  }
});
};

// Initialize 
$(van.init);

